import React, { useState } from 'react';
import './PasswordProtection.css';

const PasswordProtection = ({ children, correctPassword = "1235" }) => {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (password === correctPassword) {
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Incorrect password. Please try again.');
      setPassword('');
    }
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setError(''); // Clear error when user starts typing
  };

  if (isAuthenticated) {
    return children;
  }

  return (
    <div className="password-protection-container">
      <div className="password-protection-content">
        <div className="password-protection-header">
          <h2 className="password-protection-title">Team Dashboard Access</h2>
          <p className="password-protection-subtitle">Please enter the access code to continue</p>
        </div>

        <form onSubmit={handleSubmit} className="password-protection-form">
          <div className="password-protection-input-group">
            <input
              type="password"
              value={password}
              onChange={handlePasswordChange}
              placeholder="Enter access code"
              className="password-protection-input"
              autoFocus
            />
          </div>

          {error && (
            <div className="password-protection-error">
              {error}
            </div>
          )}

          <button type="submit" className="password-protection-button">
            Access Dashboard
          </button>
        </form>

        <div className="password-protection-footer">
          <p className="password-protection-hint">
            🔒 This area is restricted to team members only
          </p>
        </div>
      </div>
    </div>
  );
};

export default PasswordProtection; 